<template>
  <div :class="$style.wrapper">
    <div :class="$style.container">
      <div :class="$style.buttons">
        <span :class="$style.button"></span>
        <span :class="$style.button"></span>
        <span :class="$style.button"></span>
      </div>
      <div :class="$style.title">
        <img src="@/assets/lesson4/analytics.svg" :class="$style.img" alt="analytics">
        <span> App Dev Tools // </span>
        <span>{{headerTitleList[currentTask]}}</span>
      </div>
      <div :class="$style.steps">
        {{currentTask+1}}/5
      </div>
      <div :class="$style.points">
        <span :class="$style.points__measure">Баллов</span>
        <span :class="$style.points__number">{{computedPoints}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    currentTask: Number,
    points: Number,
  },
  computed: {
    computedPoints() {
      return this.points < 10 ? `0${this.points}` : this.points
    },
  },
  data() {
    return {
      headerTitleList: ['Аналитика', 'Дизайн', 'Программирование', 'Тестирование', 'Размещение'],
    }
  },
}
</script>

<style lang="scss" module>
  .wrapper{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 5rem;
    background-color: #252525;
    @media #{$m-mobile} {
      height: 10rem;
      background-color: white;
    }
  }
  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    background-color: white;
    border-radius: 25px 25px 0 0;
    @media #{$m-mobile} {
      padding-left: 4rem;
      padding-right: 4rem;
      border-radius: 0;
    }
  }
  .buttons {
    display: flex;
    align-items: center;
    @media #{$m-mobile} {
      display: none;
    }
  }
  .button {
    display: inline-block;
    width: 1.2rem;
    height: 1.2rem;
    margin-left: 0.5rem;
    border-radius: 50%;
    border: 1px solid black;
  }
  .title {
    display: flex;
    align-items: center;
    span {
      font-size: 1.8rem;
      background: linear-gradient(180deg, #3D84ED 0%, #1B5FC5 100.09%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      white-space: pre-wrap;
    }
    @media #{$m-mobile} {
      display: none;
    }
  }
  .steps {
    font-size: 1.7rem;
    letter-spacing: 0.2rem;
    @media #{$m-mobile} {
      display: none;
    }
  }
  .points {
    display: none;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    font-size: 3rem;
    &__number {
      font-size: 5rem;
      font-weight: bold;
      letter-spacing: -0.1em;
      text-align: center;
      color: $color-pink;
    }
    @media #{$m-mobile} {
      display: flex;
    }
  }
</style>
